import ValidatedTextField from './ValidatedTextField';

export { Props } from './ValidatedTextField';
export default ValidatedTextField;
